import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CdkMenuModule } from "@angular/cdk/menu";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyPaginatorModule as MatPaginatorModule } from "@angular/material/legacy-paginator";

import { IconModule } from "@shared/components/icon/icon.module";
import { NetPaymentOrdersComponent } from "./net-payment-orders.component";
import { InputWrapperModule } from "@shared/components/input-wrapper/input-wrapper.module";
import { NetPaymentHeaderComponent } from "./_components/net-payment-header/net-payment-header.component";
import { NetPaymentActionsComponent } from "./_components/net-payment-actions/net-payment-actions.component";
import { NetPaymentDataComponent } from "./_components/net-payment-data/net-payment-data.component";
import { MilestoneCardsModule } from "@shared/components/milestone-cards/milestone-cards.module";
import { NoItemsLayoutModule } from "../../shared/components/no-items-layout/no-items-layout.module";
import { SearchAutocompleteComponent } from "src/app/standalone/search-autocomplete/search-autocomplete.component";
import { BreadcrumbsModule } from "@shared/components/breadcrumbs/breadcrumbs.module";

@NgModule({
	declarations: [
		NetPaymentOrdersComponent,
		NetPaymentHeaderComponent,
		NetPaymentActionsComponent,
		NetPaymentDataComponent
	],
	imports: [
		CommonModule,
		CdkMenuModule,
		IconModule,
		InputWrapperModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MilestoneCardsModule,
		NoItemsLayoutModule,
		SearchAutocompleteComponent,
		MatPaginatorModule,
		BreadcrumbsModule
	],
	exports: [NetPaymentOrdersComponent]
})
export class NetPaymentOrdersModule {}
